import { Pipe, PipeTransform } from '@angular/core';
import { PagingOptions } from '@jms/model';

@Pipe({
  name: 'pageCount',
  standalone: true
})
export class PageCountPipe implements PipeTransform {

  transform(paging: PagingOptions, total: number, refined: boolean, message: string = ''): string {

    if (!paging) return '';

    if (total === 0 || !total)
      return 'No results found';

    total = total ? total : 0;
    const pageSize = paging?.pageSize ? paging.pageSize : 50;
    const maxPages = Math.ceil(total / pageSize);

    const filterApplied = refined ? ' - Filter Applied' : '';

    message = total === 1 ? message : `${message}s`;


    return `Page ${paging.currentPage + 1} of ${maxPages} (${total} ${message}${filterApplied})`;
  }

}
